<ng-template #loadingContractsTemplate>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading Contracts...</p>

</ng-template>

<ng-template #loadingCompanyTemplate>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading Company...</p>

</ng-template>

<ng-template #loadingBoxesTemplate>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading Boxes...</p>

</ng-template>


<ng-template #loadingTestbedsTemplate>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading Testbeds...</p>

</ng-template>

<div fxLayout="column" class="mt-2_5" fxLayoutAlign="center stretch" fxLayoutGap="3%">

  <ng-container *awIsInAnyRole="[roles.customer, roles.tester]">
    <ng-container *ngIf="company else loadingCompanyTemplate">
      <h1><strong>My company</strong></h1>
      <div fxLayout="row wrap">
        <aw-company-card [element]="company"></aw-company-card>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic, roles.tester]">
    <ng-container *ngIf="!loadingContracts else loadingContractsTemplate">
      <ng-container *ngIf="isThereAnyContract">
        <h1><strong>Contracts</strong></h1>
        <div fxLayout="row wrap" fxLayoutGap="3%">
          <aw-contract-card (onElementRemoved)="removeContract(contract)" *ngFor="let contract of contracts"
            [element]="contract" class="mb-2_5" fxFlex="30"></aw-contract-card>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic]">
    <ng-container *ngIf="!loadingBoxes else loadingBoxesTemplate">
      <ng-container *ngIf="isThereAnyBox">
        <h1><strong>Boxes</strong></h1>
        <div fxLayout="row wrap" fxLayoutGap="3%">
          <aw-box-card (onElementRemoved)="removeBox(box)" *ngFor="let box of boxes" [element]="box"
            class="mb-2_5"></aw-box-card>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *awIsInAnyRole="[roles.researcher]">
    <ng-container *ngIf="!loadingBoxesAndTestbeds else loadingBoxesTemplate">
      <h1 class="text-left"><strong>Boxes</strong></h1>
      <ng-container *ngIf="isThereAnyBox; else noBoxAvailable">
        <div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="3%">
          <aw-box-card-researcher *ngFor="let box of boxesWithTestbed" [element]="box"
            class="mb-2_5"></aw-box-card-researcher>
        </div>
      </ng-container>
      <ng-template #noBoxAvailable>
        <h3>You have no boxes available right now.</h3>
      </ng-template>
    </ng-container>
  </ng-container>

  <!--  <ng-container *awIsInAnyRole="[roles.researcher]">-->
  <!--    <ng-container *ngIf="!loadingBoxesAndTestbeds else loadingTestbedsTemplate">-->
  <!--      <ng-container *ngIf="isThereAnyTestbed">-->
  <!--        <h1><strong>Testbeds</strong></h1>-->
  <!--        <div fxLayout="row wrap" fxLayoutGap="3%">-->
  <!--          <aw-testbed-card *ngFor="let testbed of testbeds" [element]="testbed" class="mb-2_5"></aw-testbed-card>-->
  <!--        </div>-->
  <!--      </ng-container>-->
  <!--    </ng-container>-->
  <!--  </ng-container>-->

  <!--  <ng-container *ngIf="isThereAnyCertificate">-->
  <!--    <ng-container *ngIf="certificates?.length !== 0 else loadingCertificates">-->
  <!--      <h1><strong>Certificates</strong></h1>-->
  <!--      <div ffxLayout="row map" fxFlex="25%" fxLayoutGap="3% grid">-->
  <!--        <aw-certificates-card *ngFor="let cerificate of certificates" [element]="certificate"></aw-certificates-card>-->
  <!--      </div>-->
  <!--    </ng-container>-->
  <!--  </ng-container>-->


</div>